import { IPromotion, Promotion } from "@/models/promotion.entity";
import { BackwardsCompatibleDataAccessLayer } from "@/store/backwards-compatible-paginated.store";

export const PromotionDataAccessLayer = new (class extends BackwardsCompatibleDataAccessLayer<IPromotion> {
  protected mapEntity(entity: IPromotion): IPromotion {
    return new Promotion(entity);
  }
})();
